<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('CyclicLineTool', function() {
            return {
                // Descriptor for the tool
                group: 'Cyclic', category: 'Cycles', icon: this.getIcon('cyclic'),
                name: 'Cyclic Lines',
                type: 'Time',
                hint: 'Cyclic Lines',
                data: [],     // Default data
                settings: { price: false, time: true }, // Default settings
            }
        }, 'Cyclic Lines')
</script>
